import { TypeKeys, ActionTypes } from '../actions/index';
import { isInIframe } from '../global/firebase';

const getInitialState = (): UiState => {
  return {
    fromRoute: null,
    toRoute: null,
    globalModalShown: false,
    online: true,
    isInIframe: isInIframe(),
  };
};

const ui = (state = getInitialState(), action: ActionTypes): UiState => {
  switch (action.type) {
    case TypeKeys.SET_ROUTE_DETAIL: {
      return {
        ...state,
        fromRoute: action.routeDetail.from,
        toRoute: action.routeDetail.to,
      };
    }
    case TypeKeys.SIGN_OUT: {
      return { ...getInitialState() };
    }
    case TypeKeys.GLOBAL_MODAL_SHOWN: {
      return {
        ...state,
        globalModalShown: action.globalModalShown,
      };
    }
    case TypeKeys.TOGGLE_ONLINE: {
      return {
        ...state,
        online: action.online,
      };
    }
  }
  return state;
};

export default ui;
